import React from "react";

const CardSection = () => {
 

  const textStyle = {
    color: "#5f5f5f",
  };

  const headingStyle = {
    fontWeight: "500",
    fontSize: "24px",
    color: "#5f5f5f",
  };

  const redLine = {
    width: "40px",
    height: "3px",
    backgroundColor: "#eb4d4b",
    marginBottom: "10px",
  };

  return (
    <div className="container-fluid"
       data-sal-delay="150"
              data-sal="slide-up"
              data-sal-duration="800"    
    >
      <div className="container">
        <h3 className="text-danger title split-collab" style={{fontSize : '3rem' , textAlign : "center" , marginTop : "30px"}}>Insights & Innovations in IT Modernization</h3>
        <div className="row">
          {/* Card 1 */}
          <div className="col-md-6 mb-4">
            <div className="card border-0 h-100">
              <div className="card-body p-0">
                <div
                  style={{
                    width: "100%",
                    height: "300px",
                    //backgroundColor: "#ddd",
                    backgroundImage : "url('../assets/images/IT_Consulting_Images/modernization.jpg')",
                    backgroundSize : "cover"
                    
                  }}
                >
                  {/* Left Image Space */}
                </div>
                <div className="p-4">
                  <div style={redLine}></div>
                  <h5 style={headingStyle}>
                    Unlock the full potential of your IT Infrastructure
                  </h5>
                  <p style={textStyle}>
                   Starparth Technologies for IT Operations combines AI-driven insights from the Starparth Technologies platform with experts from Starparth Consult. It uses data-driven analysis, predictive analytics and automation to provide tailored actions to improve operational efficiency, IT incident reduction, compliance and resilience
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Card 2 */}
          <div className="col-md-6 mb-4">
            <div className="card border-0 h-100">
              <div className="card-body p-0">
                <div
                  style={{
                    width: "100%",
                    height: "300px",
                    // backgroundColor: "#ddd",
                     backgroundImage : "url('../assets/images/IT_Consulting_Images/it-potential.jpeg')",
                    backgroundSize : "cover"
                  }}
                >
                  {/* Right Image Space */}
                </div>
                <div className="p-4">
                  <div style={redLine}></div>
                  <h5 style={headingStyle}>
                    Starparth releases its second annual global mainframe modernization survey report
                  </h5>
                  <p style={textStyle}>
                    A consultative approach can help mainframe users with
                    modernization strategies to transform their organizations.
                    This survey of 500 senior leaders helps understand what is
                    top-of-mind for respondents: generative AI, hybrid IT,
                    security, skills and observability.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CardSection;
